// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.search-bar {
  display: flex;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}

.search-bar input {
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-radius: 5px 0 0 5px;
  border-right: none;
  box-shadow: 5px 5px 5px rgba(170, 170, 170, 0.5);
}

button.clear-button.button.secondary.icon.icon-remove {
  border: 1px solid rgba(128, 128, 128, 0.2);
  border-left: none;
  transition: color 0.5s;
  box-shadow: 5px 5px 5px rgba(170, 170, 170, 0.5);
}

button.clear-button.button.secondary.icon.icon-remove:hover {
  background-color: white;
  color: #d3d3d3;
}

.search-btn {
  background: #0066b2;
  color: white;
  padding: 15px 15px 15px 24px;
  height: 48px;
  width: 65px;
  box-shadow: 5px 5px 5px rgba(170, 170, 170, 0.5);
  border-radius: 0 5px 5px 0;
}

.search-btn:hover {
  cursor: pointer;
}

.search-input {
  height: 48px;
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
